export enum EnPrescriptionViewMode {
    list = 'list',
    items = 'items',
    print = 'print'
}
